import { TTBFraudTableDataType, TTB_FRAUD_WARNING } from '../../types/tryThenBuyFraud';

export const getProductNameFromHeadModel = (data: any) => {
  try {
    const modelInfo = data?.selectedNodes?.find((item: any) => item.name === 'Model');
    if (!modelInfo) return '';
    return modelInfo?.option?.name || modelInfo?.option?.info?.name;
  } catch (error) {
    return '';
  }
};

export const getProductImageUrlFromSelectNodes = (data: any) => {
  try {
    const modelInfo = data?.selectedNodes?.find((item: any) => item.name === 'Model');
    if (!modelInfo) return '';
    return (
      modelInfo?.option?.imageURL ||
      modelInfo?.option?.info?.imageUrl ||
      modelInfo?.option?.info?.imageUrlLarge ||
      modelInfo?.option?.info?.imageUrlMedium ||
      modelInfo?.option?.info?.imageUrlSmall
    );
  } catch (error) {
    return '';
  }
};

export const getDetectionHighlightTTBFraud = (record: TTBFraudTableDataType) => {
  const potentialFraud = isNaN(Number(record.potentialFraud)) ? 0 : Number(record.potentialFraud);
  if (potentialFraud > 75) {
    return TTB_FRAUD_WARNING.RED;
  }
  if (potentialFraud > 49) {
    return TTB_FRAUD_WARNING.ORG;
  }
  if (potentialFraud > 1) {
    return TTB_FRAUD_WARNING.GREEN;
  }
  return TTB_FRAUD_WARNING.ORIGINAL;
};
